import React from "react";
import { Button } from "../../../components/ui/button";
import { RepositoryFilterMode } from "../types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

interface RepositoryFiltersProps {
  filter: RepositoryFilterMode;
  owner: string;
  owners: string[];
  onChangeFilter: (next: RepositoryFilterMode) => void;
  onChangeOwner: (owner: string) => void;
}

const RepositoryFilters = ({
  filter,
  owner,
  owners,
  onChangeFilter,
  onChangeOwner,
}: RepositoryFiltersProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant={filter === "all" ? "default" : "outline"}
        size="sm"
        onClick={() => onChangeFilter("all")}
      >
        All
      </Button>
      <Button
        variant={filter === "favorites" ? "default" : "outline"}
        size="sm"
        onClick={() => onChangeFilter("favorites")}
      >
        Favorites
      </Button>
      {owners.length > 1 ? (
        <Select value={owner || "__all__"} onValueChange={(value) => onChangeOwner(value === "__all__" ? "" : value)}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Owner" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">All owners</SelectItem>
            {owners.map((item) => (
              <SelectItem key={item} value={item}>
                {item}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : null}
    </div>
  );
};

export default RepositoryFilters;
